import { useTranslation } from 'react-i18next';
import { Preloader } from '@/components/Preloader';
import Icon from './icon_empty.svg'
import s from './index.module.scss';

export const LenderFundraisingEmptyState = ({ isLoading }) => {
  const { t } = useTranslation();

  return (
    <div className={s.page}>
      <div className="container-inner">
        <h1 className="f-hero-h2">{t('fundraising:page.title')}</h1>
        {isLoading ? (
          <Preloader style={{ height: '40vh' }} />
        ) : (
          <div className={s.empty}>
            <div className={s.empty_content}>
              <img src={Icon} alt="empty" width={64} height={64} />
              <div className="f-article-accent" style={{ marginTop: '16px' }}>
                {t('fundraising:lender.no_fundraising_yet')}
              </div>
              <div className="f-small-regular" style={{ marginTop: '2px' }}>
                {t('fundraising:lender.application_will_appear')}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};